import React from 'react';
import { Button, Grid, Header, Icon, Label, Loader, Popup, Responsive, Segment, Tab, Table } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';

import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import { ExportReactCSV } from '../../util/ExportCSV';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from "../../util/PaginationFront";
import { FiltersOnStyle, IconHeader } from '../ProfessorInputGrades/css';
import { fetchStudyType } from '../../Lookups/util';
import {extractFileNameFromHeaders} from "../../DegreeDocumentPrint/util/util";
import download from "downloadjs";
import ReactExport from 'react-data-export';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p><FormattedMessage id="professorStatistics.noStudents" /></p>;
const NoData = () => <p><FormattedMessage id="professorStatistics.noCourses" /></p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class CourseStudents extends React.Component {
    constructor(props) {
        super(props);

        let storedCourseImplementationId = '';
        let storedCourseImplementationName = '';

        if (localStorage.getItem('courseImplementationId')) {
            storedCourseImplementationId = parseInt(localStorage.getItem('courseImplementationId'), 10);
        }

        if (localStorage.getItem('courseImplementationName')) {
            storedCourseImplementationName = parseInt(localStorage.getItem('courseImplementationName'), 10);
        }

        this.state = {
            data: [],
            courseDetails: [],
            // types: [],
            courseImplementationId: storedCourseImplementationId,
            courseImplementationName: storedCourseImplementationName,

            loading: true,
            activeIndex: 0,

            isLoading: false,
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
            excelData: [],

            courseRoleType: localStorage.getItem('courseRoleType') ? localStorage.getItem('courseRoleType') : ''
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getStudents = this.getStudents.bind(this);
        this.getStudentsPDF = this.getStudentsPDF.bind(this);
        this.getCourseDetails = this.getCourseDetails.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    formatEnrolmentCount(enrolmentCount) {
        if (enrolmentCount === null || enrolmentCount === undefined) {
            return '-';
        } else if (enrolmentCount === -1) {
            return 'Apsolventski staž';
        } else {
            return enrolmentCount + '. put';
        }
    }

    componentDidMount() {
        console.log('this.props.studyPrograms.', this.props.studyPrograms);
        if (this.props.location.state) {
            localStorage.setItem('courseImplementationId', this.props.location.state.courseImplementationId);
            localStorage.setItem('courseImplementationName', this.props.location.state.courseImplementationName);
            localStorage.setItem('employeeId', this.props.location.state.employeeId);
            this.getStudents(this.props.location.state.courseImplementationId);
            this.getCourseDetails(this.props.location.state.courseImplementationId);
        }
        // fetchStudyType().then(
        //     (types)=>{
        //         this.setState({types: types.data})
        //     }
        // )

        this.getStudents(parseInt(localStorage.getItem('courseImplementationId'), 10));
        this.getCourseDetails(parseInt(localStorage.getItem('courseImplementationId'), 10));
        this.getEnrolmentCount();
    }

    getCourseDetails(courseImplementationId) {
        axios.get((localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA') ? `/course/csp-info/${courseImplementationId}/${localStorage.getItem('orgUnit')}`
            : `/course/csp-info/${courseImplementationId}/`)
            .then(res => {
                const courseDetails = res.data;
                this.setState({ courseDetails, loaded: true });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch course details');
            });
    }

    getStudents(courseImplementationId) {
        let obj = {};
        axios({
            method: 'post',
            url: localStorage.getItem('activeRole').substr(0, 8) === 'Profesor' || localStorage.getItem('activeRole').substr(0, 8) === 'Asistent'
                ? `course/students/${parseInt(localStorage.getItem('courseImplementationId'), 10)}/${window.$locale}`
                : (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator')?
                    `course/students/${parseInt(localStorage.getItem('courseImplementationId'), 10)}/${parseInt(localStorage.getItem('employeeId'), 10)}/${localStorage.getItem('courseRoleType')}/${window.$locale}/${localStorage.getItem('orgUnit')}`
               : `course/students/${parseInt(localStorage.getItem('courseImplementationId'), 10)}/${parseInt(localStorage.getItem('employeeId'), 10)}/${localStorage.getItem('courseRoleType')}/${window.$locale}`,
            data: { ...obj }
        })
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el,
                        // studyType: this.state.types.find(e=> e.id === el.studyTypeId).displayName,
                        department: el.departmentsSPOU[0].organizationalUnitName,
                        studyProgram: el.studyProgramBasicName ==='-' ? el.departmentsSPOU[0].organizationalUnitName + ' | ' + el.studyProgramName : el.studyProgramBasicName + ' | ' + el.studyProgramName
                    })).sort((a, b) => a.lastName.localeCompare(b.lastName) || a.firstName.localeCompare(b.firstName)),
                    loading: false
                });
                const excelData = res.data.sort((a, b) => a.lastName.localeCompare(b.lastName) || a.firstName.localeCompare(b.firstName))
                    .map(el => ([
                    { value: el.lastName + ' ' + el.firstName},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyTypeName},
                    { value: el.index},
                        { value: this.formatEnrolmentCount(el.numberOfEnrollments) }
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });
    }

    getEnrolmentCount(){
        this.setState({
            additionalLoading: true,
        })
        const enrolmentCountUrl = localStorage.getItem('activeRole').substr(0, 8) === 'Profesor' || localStorage.getItem('activeRole').substr(0, 8) === 'Asistent'
            ? `course/students/${parseInt(localStorage.getItem('courseImplementationId'), 10)}/${window.$locale}/enrolment-count`
            : (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator')?
                `course/students-enrolment-count/${parseInt(localStorage.getItem('courseImplementationId'), 10)}/${parseInt(localStorage.getItem('employeeId'), 10)}/${localStorage.getItem('courseRoleType')}/${window.$locale}/${localStorage.getItem('orgUnit')}`
                : `course/students-enrolment-count/${parseInt(localStorage.getItem('courseImplementationId'), 10)}/${parseInt(localStorage.getItem('employeeId'), 10)}/${localStorage.getItem('courseRoleType')}/${window.$locale}`;

        axios.post(enrolmentCountUrl, {})
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el,
                        // studyType: this.state.types.find(e=> e.id === el.studyTypeId).displayName,
                        department: el.departmentsSPOU[0].organizationalUnitName,
                        studyProgram: el.studyProgramBasicName ==='-' ? el.departmentsSPOU[0].organizationalUnitName + ' | ' + el.studyProgramName : el.studyProgramBasicName + ' | ' + el.studyProgramName
                    })).sort((a, b) => a.lastName.localeCompare(b.lastName) || a.firstName.localeCompare(b.firstName)),
                    loading: false,
                    additionalLoading: false,
                });
                const excelData = res.data.sort((a, b) => a.lastName.localeCompare(b.lastName) || a.firstName.localeCompare(b.firstName))
                    .map(el => ([
                        { value: el.lastName + ' ' + el.firstName},
                        { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.studyTypeName},
                        { value: el.index},
                        { value: this.formatEnrolmentCount(el.numberOfEnrollments) }
                    ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });
    }

    getStudentsPDF() {
        const activeRole = localStorage.getItem('activeRole') || '';
        const professorOrAssistant = activeRole.substr(0, 8) === 'Profesor' || activeRole.substr(0, 8) === 'Asistent';
        let obj = {
            courseImplementationId : localStorage.getItem('courseImplementationId'),
            employeeId: localStorage.getItem('employeeId'),
            role : activeRole.substr(0, 8) === 'Profesor' ? 'profesor' :
                activeRole.substr(0, 8) === 'Asistent' ? 'asistent' : localStorage.getItem('courseRoleType'),
            organizationalUnitId : professorOrAssistant ? localStorage.getItem('organizationalUnitId') : localStorage.getItem('orgUnit'),
            language: 'bs'
        };
        axios({
            method: 'post',
            url: '/documents/course-implementation-students',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        const headersForExport = [
            { label: 'Prezime', key: 'lastName' },
            { label: 'Ime', key: 'firstName' },
            { label: 'Index', key: 'index' },
            { label: 'Odsjek', key: 'department' },
            { label: 'Studijski program', key: 'studyProgram' },
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime i ime', width: { wpx: 250 } },
                    { title: 'Odsjek', width: { wpx: 200 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'Plan i program', width: { wpx: 300 } },
                    { title: 'Tip studija', width: { wpx: 200 } },
                    { title: 'Index', width: { wpx: 150 } },
                    {
                        title: 'Broj upisa u trenutni semestar',
                        width: { wpx: 200 }
                    },
                ],
                data: this.state.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                <Header as="h1"><FormattedMessage id="common.details" /></Header>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            <Header.Content>
                                {localStorage.getItem('courseImplementationName')}
                                <Header.Subheader floated="left">
                                    {(localStorage.getItem('courseComment')) === 'null' ? <FormattedMessage id="common.course" /> : localStorage.getItem('courseComment')}
                                </Header.Subheader>
                                {/* <Header.Subheader> <FormattedMessage id="common.course" /></Header.Subheader> */}
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                               <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>


                        </Header>
                    </Segment>

                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                    <Segment>
                        <div>

                            {currentPosts.length ? <Table celled selectable compact>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan={17} >
                                                 <span>
                                                <Grid stackable columns={2} >

                                                         <Grid.Column width={12}>
                                                         <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'department', 'studyProgramName', 'studyProgramBasicName', 'studyProgramName', 'studyTypeName']} />
                                                      </Grid.Column>
                                                    <Grid.Column width={2} style={{ paddingRight: '5px' }}>
                                                            <Popup
                                                                trigger={
                                                                    <Button
                                                                        animated="vertical"
                                                                        fluid
                                                                        color="red"
                                                                        basic
                                                                        onClick={this.getStudentsPDF}
                                                                    >
                                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                        <Button.Content visible>
                                                                            PDF
                                                                        </Button.Content>
                                                                    </Button>
                                                                }
                                                                content="Preuzmi spisak u PDF-u"
                                                                hideOnScroll
                                                                position="top center"
                                                            />
                                                        </Grid.Column>
                                                      <Grid.Column width={2} style={{paddingLeft: '5px'}}>

                                                         {this.state.data &&
                                                         <ExcelFile filename="Spisak studenata na predmetu" element={<Popup
                                                             trigger={<Button disabled={this.state.additionalLoading} animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                                 <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                 <Button.Content visible>
                                                                     Excel
                                                                 </Button.Content>
                                                             </Button>}
                                                             content="Preuzmi spisak u Excel-u"
                                                             hideOnScroll
                                                             position="top center"
                                                         />}>
                                                             <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studenti" />
                                                         </ExcelFile>
                                                         // <ExportReactCSV color="green" csvData={ this.getDataToRender()} headers={headersForExport} floated="right" fileName="Spisak studenata na predmetu" fluid />
                                                         }
                                                      </Grid.Column>
                                                </Grid>

                                            </span>
                                                  {/*<span>*/}
                                                  {/*   {this.state.data && <ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} floated="right" fileName="Spisak studenata na predmetu" />}*/}
                                                  {/*       <SearchTableData data={this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'department', 'studyProgramName', 'studyProgramBasicName']} />*/}
                                                  {/*</span>*/}
                                            </Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.HeaderCell width="1"><FormattedMessage id="common.ordinal" /></Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>

                                            <Header as="h4" image>
                                                <Header.Content>
                                                    <FormattedMessage id="common.studentLastNameAndFirstName" />
                                                    <Header.Subheader> <FormattedMessage id="common.index" /></Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}><FormattedMessage id="common.department" /></Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}><FormattedMessage id="common.studyProgram" /></Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}><FormattedMessage id="common.studyType" /></Table.HeaderCell>
                                            <Table.HeaderCell colSpan={2}><FormattedMessage id="common.enrolmentCountInSemester" /></Table.HeaderCell>
                                            <Table.HeaderCell colSpan={2} />

                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body> {currentPosts.map((el, index) =>
                                        (<Table.Row key={el.id}>
                                                <Table.Cell verticalAlign="middle" width="1">
                                                    {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                                </Table.Cell>
                                                <Table.Cell colSpan={3} verticalAlign="middle">

                                                                     {el.lastName} {el.firstName}
                                                    {el.droppedOut ? (
                                                        <span style={{ float: 'right', display: 'inline-flex', alignItems: 'center', gap: '6px', marginLeft: '8px' }}>
                                                <Popup
                                                    content={<FormattedMessage id="common.droppedOut" />}
                                                    trigger={<Icon name="sign-out" color="red" />}
                                                    on="hover"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </span>
                                                    ) : null}

                                                                        <span style={{ color: '#a6a4a1' }}><br/>{el.index}</span>

                                                </Table.Cell>
                                                <Table.Cell colSpan={3} verticalAlign="middle" >
                                                    {el.departmentsSPOU[0].organizationalUnitName}
                                                </Table.Cell>
                                                <Table.Cell colSpan={3} verticalAlign="middle" >
                                                    <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                                </Table.Cell>
                                                <Table.Cell colSpan={3} verticalAlign="middle" >
                                                    {this.state.additionalLoading ?
                                                    <Loader active inline="centered" size={"tiny"}/>
                                                    : el.studyTypeName}
                                                </Table.Cell>
                                                <Table.Cell colSpan={2} verticalAlign="middle">
                                                    {this.state.additionalLoading ?
                                                        <Loader active inline="centered" size={"tiny"}/>
                                                        : this.formatEnrolmentCount(el.numberOfEnrollments)}
                                                </Table.Cell>
                                                <Table.Cell colSpan={2} textAlign="center" verticalAlign="middle" >
                                                    {(localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') ?
                                                        <FormattedMessage id="route.studentsInfoSS">
                                                            {(msg) => (<Link style={{ textDecoration: 'none' }} to={{ pathname: msg, state: { studentId: el.studentId, sspId: el.id, studyProgramId: el.studyProgramId, } }}>
                                                                <Button color="blue" basic="true">
                                                                    <FormattedMessage id="professorInputGrades.info" />
                                                                </Button>
                                                            </Link>)}
                                                        </FormattedMessage>
                                                        : <FormattedMessage id="route.studentsInfo">
                                                            {(msg) => (<Link style={{ textDecoration: 'none' }} to={{ pathname: msg, state: { studentId: el.studentId, sspId: el.id, studyProgramId: el.studyProgramId, } }}>
                                                               <Button
                                                                style={FiltersOnStyle}
                                                                size="medium"
                                                                color="blue"
                                                                basic
                                                            ><FormattedMessage id="professorInputGrades.info" /></Button>
                                                            </Link>)}
                                                        </FormattedMessage>}
                                                </Table.Cell>

                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                                : <NoDataMessage />
                            }

                            {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                            <ToastContainer hideProgressBar />

                        </div>
                        </Segment>
                    }

                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/Courses/CourseStudents.js